var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.contentClass },
    [
      _c("vue-title", {
        attrs: { title: _vm.$t("identityProvider:securityQuestions:title") }
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_vm.$t("identityProvider:securityQuestions:title")))
      ]),
      _vm._v(" "),
      _vm.model.showError
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "validation-summary-errors alert alert-danger fade show",
                attrs: {
                  role: "alert",
                  "data-valmsg-summary": "true",
                  "data-test-element": "idp-alert-danger-generic"
                }
              },
              [
                _c("span", { staticClass: "alert-icon" }, [_vm._v("⚠")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.model.errorMessage))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button",
                attrs: {
                  type: "button",
                  name: "Action:RedirectToLogin",
                  disabled: _vm.disabled
                },
                on: { click: _vm.loginCancel }
              },
              [_vm._v(_vm._s(_vm.$t("shared:action:back")))]
            )
          ])
        : _c("div", [
            _c(
              "form",
              {
                ref: "form",
                attrs: {
                  action: "authentication/setupquestions",
                  autocomplete: "off"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.validateBeforeSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.any(),
                        expression: "errors.any()"
                      }
                    ],
                    staticClass:
                      "validation-summary-errors alert alert-danger fade show",
                    attrs: {
                      role: "alert",
                      "data-valmsg-summary": "true",
                      "data-test-element": "security-questions-warning"
                    }
                  },
                  [
                    _c("span", { staticClass: "alert-icon" }, [_vm._v("⚠")]),
                    _vm._v(" "),
                    _vm.errors.has(".")
                      ? _c("span", [_vm._v(_vm._s(_vm.errors.first(".")))])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.$t("validation:summary")))
                        ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("div", { staticClass: "panel-message" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.model.instructions) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.model.questions, function(question, i) {
                      return _c("div", [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "label",
                              attrs: {
                                "data-test-element":
                                  "security-question-label-" + (i + 1)
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "identityProvider:securityQuestions:question"
                                  )
                                ) +
                                  " " +
                                  _vm._s(i + 1)
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.model.availableQuestions.length > 1
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.model.questions[i].id,
                                      expression: "model.questions[i].id"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: ("required", "not_in:null"),
                                      expression: "'required', 'not_in:null'"
                                    }
                                  ],
                                  staticClass:
                                    "security-question control security-answer-padding",
                                  class: {
                                    "input-validation-error": _vm.hasErrorOn(
                                      "question" + i
                                    )
                                  },
                                  attrs: {
                                    name: "question" + i,
                                    "data-vv-as":
                                      _vm.$t(
                                        "identityProvider:securityQuestions:question"
                                      ) +
                                      " " +
                                      (i + 1),
                                    "data-test-element":
                                      "security-question-" + (i + 1)
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.model.questions[i],
                                          "id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.changeQuestion
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "null" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "identityProvider:securityQuestions:defaultOption"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.model.availableQuestions[i],
                                    function(availableQuestion) {
                                      return _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: availableQuestion.id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(availableQuestion.text) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm.model.availableQuestions.length == 1
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.model.questions[i].id,
                                      expression: "model.questions[i].id"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: ("required", "not_in:null"),
                                      expression: "'required', 'not_in:null'"
                                    }
                                  ],
                                  staticClass:
                                    "security-question control security-answer-padding",
                                  class: {
                                    "input-validation-error": _vm.hasErrorOn(
                                      "question" + i
                                    )
                                  },
                                  attrs: {
                                    name: "question" + i,
                                    "data-vv-as":
                                      _vm.$t(
                                        "identityProvider:securityQuestions:question"
                                      ) +
                                      " " +
                                      (i + 1),
                                    "data-test-element":
                                      "security-question-" + (i + 1)
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.model.questions[i],
                                          "id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.changeQuestion
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "null" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "identityProvider:securityQuestions:defaultOption"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.model.availableQuestions[0],
                                    function(availableQuestion) {
                                      return _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: availableQuestion.id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(availableQuestion.text) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasErrorOn("question" + i),
                                  expression: "hasErrorOn('question'+i)"
                                }
                              ],
                              staticClass: "field-validation-error",
                              attrs: {
                                "data-test-element":
                                  "security-question-error-" + (i + 1)
                              }
                            },
                            [_vm._v(_vm._s(_vm.errors.first("question" + i)))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "label",
                              attrs: {
                                "data-test-element":
                                  "security-answer-label-" + (i + 1)
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "identityProvider:securityQuestions:answer"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.questions[i].answer,
                                expression: "model.questions[i].answer"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  regex:
                                    _vm.model.answerComplexity.answerPattern,
                                  min:
                                    _vm.model.answerComplexity
                                      .answerMinimumLength,
                                  max:
                                    _vm.model.answerComplexity
                                      .answerMaximumLength
                                },
                                expression:
                                  "{ required: true, regex: model.answerComplexity.answerPattern, min: model.answerComplexity.answerMinimumLength, max: model.answerComplexity.answerMaximumLength }"
                              }
                            ],
                            staticClass: "control",
                            class: {
                              "input-validation-error": _vm.model
                                .isSecureNowEnabled
                                ? _vm.hasErrorOn("snanswer" + i)
                                : _vm.hasErrorOn("answer" + i)
                            },
                            attrs: {
                              type: "password",
                              name: _vm.model.isSecureNowEnabled
                                ? "snanswer" + i
                                : "answer" + i,
                              "data-vv-as": _vm.$t(
                                "identityProvider:securityQuestions:answer"
                              ),
                              autocomplete: "off",
                              "data-test-element": "security-answer-" + (i + 1)
                            },
                            domProps: { value: _vm.model.questions[i].answer },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model.questions[i],
                                  "answer",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.model.isSecureNowEnabled
                                    ? _vm.hasErrorOn("snanswer" + i)
                                    : _vm.hasErrorOn("answer" + i),
                                  expression:
                                    "model.isSecureNowEnabled ? hasErrorOn('snanswer'+i) : hasErrorOn('answer'+i)"
                                }
                              ],
                              staticClass: "field-validation-error",
                              attrs: {
                                "data-test-element":
                                  "security-answer-error-" + (i + 1)
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.isSecureNowEnabled
                                    ? _vm.errors.first("snanswer" + i)
                                    : _vm.errors.first("answer" + i)
                                )
                              )
                            ]
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          attrs: {
                            type: "submit",
                            name: "Action:SubmitQuestions",
                            disabled: _vm.disabled,
                            "data-test-element": "security-question-submit"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("shared:action:continue")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button-secondary link-text-transform",
                          attrs: {
                            "data-test-element": "security-question-cancel"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.loginCancel.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("shared:action:cancel")))]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d5bf8a6", { render: render, staticRenderFns: staticRenderFns })
  }
}